import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import UiDialogContent from 'ui-components/ui-dialog-content/UiDialogContent';
import UiDialogActions from 'ui-components/ui-dialog-actions/UiDialogActions';
import UiButton from 'ui-components/ui-button/UiButton';
import imgError from 'assets/img/500.svg';
import { useSelector } from 'react-redux';
import NetworkStatusError from './network-status-error/NetworkStatusError';
import {
  StyledDisplayError,
  StyledDisplayErrorDialog,
} from './DisplayError.styles';

const DisplayError = ({ className, error }) => {
  const { t } = useTranslation();
  const [visibleErrorModal, setVisibleErrorModal] = useState(false);
  const isClientOnline = useSelector((state) => state.pageReducer.onlineStatus);

  // شخصی سازی خطا
  const customError = {
    message: error?.message,
    status: error?.response?.status,
    errors: error?.response?.data?.errors?.data,
  };

  if (!isClientOnline) {
    return <NetworkStatusError />;
  }

  return (
    <StyledDisplayError>
      <div className={classNames(className, 'display-errors', 'text-center')}>
        <img src={imgError} />
        <div className='title'>
          {t('common:errorOccurred', { status: customError?.status })}
        </div>
        <span
          className='more-details'
          onClick={() => setVisibleErrorModal(true)}
        >
          {t('common:details')}
        </span>
        <StyledDisplayErrorDialog
          open={visibleErrorModal}
          className={classNames(`${className}-dialog`, 'display-errors-modal')}
        >
          <UiDialogContent>
            <div className='title text-center'>
              {t('common:errorOccurred', { status: customError?.status })}
            </div>
            <div>
              <pre className='block-errors'>
                {JSON.stringify(customError?.errors, null, 2)}
              </pre>
            </div>
          </UiDialogContent>
          <UiDialogActions className='actions flex center'>
            <UiButton onClick={() => setVisibleErrorModal(false)}>
              {t('common:IUnderstood')}
            </UiButton>
          </UiDialogActions>
        </StyledDisplayErrorDialog>
      </div>
    </StyledDisplayError>
  );
};

DisplayError.propTypes = {
  error: PropTypes.object,
  className: PropTypes.string,
};

export default DisplayError;
